export interface IRecommendation {
  // Required Properties
  firstName: string
  recommendationType: ProfileRecommendationType

  // Optional Properties
  about?: string
  avatar?: string
  creatorTypes?: string[]
  email?: string
  engagements?: number
  id?: string
  interests?: string[]
  lastName?: string
  location?: string
  mutualContacts?: number
  organization?: string
  socialMediaUrl?: string
  username?: string
  title?: string
  totalAudience?: number
  verified?: boolean
  company?: string
}

export enum ProfileRecommendationType {
  HOT_PROFILE = 'HotProfile',
  COLD_PROFILE = 'ColdProfile',
  GPP_PROFILE = 'GPProfile',
}
